import { render } from "./RandomQuote.vue?vue&type=template&id=7bc6393d&scoped=true"
import script from "./RandomQuote.vue?vue&type=script&lang=js"
export * from "./RandomQuote.vue?vue&type=script&lang=js"

import "./RandomQuote.vue?vue&type=style&index=0&id=7bc6393d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc6393d"]])

export default __exports__